import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import { Form, Formik, FormikErrors } from "formik";
import * as React from "react";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import ErrorMsg from "../../components/ErrorMsg";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import { useUploadDesignationMutation } from "../../services/appln";

interface FormData {
  file1: any;
}

interface Props {
  onSubmitHandler: (newObj: any) => void;
  onCancelHandler: () => void;
  state: boolean;
}

export default function UploadDesignations(props: Props) {
  const iv: FormData = {
    file1: "",
  };

  const onCancelHandlerWrapper = () => {
    props.onCancelHandler();
  };

  const [uploadFile, uploadFileParams] = useUploadDesignationMutation();

  // console.log("UploadDesignations, uploadFileParams:", uploadFileParams);
  React.useEffect(() => {
    if (uploadFileParams.isSuccess) {
      props.onSubmitHandler("dummy");
    }
  }, [uploadFileParams]);

  return (
    <div>
      <Dialog
        open={props.state}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {strings.uploadDesignation}
        </DialogTitle>
        {uploadFileParams.isError && (
          <ErrorMsg msg={strings.failedToUploadDesignation} />
        )}
        {uploadFileParams.isLoading && <ProgressIndicator />}
        <DialogContent>
          <Formik
            initialValues={iv}
            validate={(values) => {
              const errors: FormikErrors<FormData> = {};
              return errors;
            }}
            onSubmit={(values, actions) => {
              actions.setSubmitting(false);
              const formData = new FormData();
              formData.append("file1", values.file1);
              uploadFile({ formData });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <input
                        id="file"
                        name="file1"
                        type="file"
                        onChange={(event) => {
                          if (event && event.target) {
                            const target = event.target as HTMLInputElement;
                            if (target.files) {
                              const file = target.files[0];
                              setFieldValue("file1", file);
                            }
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ButtonGroup>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {strings.upload}
                        </Button>
                        <Button
                          variant="contained"
                          onClick={onCancelHandlerWrapper}
                        >
                          {strings.cancel}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
